import { ServiceLocator } from './../../../services/locator.service';
import { ApplicationState } from './../../../state/app.state';
import { UserService } from './../../../services/user/user.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { IMember, IMemberResult } from './../../../models/member';
import {
  IOrganization,
  IOrganizationBase,
} from './../../../models/organization';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, ReplaySubject } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { SidebarService } from '../../../services/sidebar.service';
import { Location } from '@angular/common';
import { App } from '../../../state/app.actions';
import { User } from '../../../users/user.actions';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],
})
export class BaseComponent implements OnDestroy {
  protected user: IMember;
  protected organization: IOrganization;
  protected organizations: Array<IOrganization>;

  title: String;
  userActions: string[];

  // @Select(UserState.getCurrentUser)
  getCurrentUser$: Observable<IMember>;

  @Select(ApplicationState.getCurrentOrganization)
  getCurrentOrganization$: Observable<IOrganization>;

  unSubscribeAll$ = new Subject<void>();

  update = new ReplaySubject();

  public sidebarVisible: boolean = true;
  public userService: UserService;
  public titleService: Title;
  public sidebarService: SidebarService;
  public dontResetTerm: boolean = false;
  public skipSetValueFromToken: boolean = false;
  location: Location;
  private localStore: Store;
  // cdr: ChangeDetectorRef;
  // TODO: refactor
  // https://stackoverflow.com/questions/42461852/inject-a-service-manually/42462579#42462579
  constructor() {
    this.userService = ServiceLocator.injector.get(UserService);
    this.sidebarService = ServiceLocator.injector.get(SidebarService);
    this.titleService = ServiceLocator.injector.get(Title);
    this.location = ServiceLocator.injector.get(Location);
    this.localStore = ServiceLocator.injector.get(Store);
    this.setValueFromToken();
    let inProgress = false;
    this.getCurrentOrganization$
      .pipe(takeUntil(this.unSubscribeAll$))
      .subscribe((result) => {
        this.organization = result;
        this.userService.loginInformation.subscribe((loginResult) => {
          // takeUntil(this.unSubscribeAll$),
          // tap( (loginResult) => {
          if (!loginResult) {
            this.userService.getCurrentUserName().then((user) => {
              if (!user) return;
              if (inProgress) return;

              inProgress = true;
              this.userService
                .getLoginInformation(user)
                .pipe(
                  // distinctUntilChanged(),
                  debounceTime(2000),
                  takeUntil(this.unSubscribeAll$)
                )
                .subscribe((result) => {
                  inProgress = false;
                  if (!this.organization)
                    this.organization = result.organizations[0];
                  if (
                    result.preferences &&
                    result.preferences.defaultOrganization
                  ) {
                    this.organization = result.organizations.find(
                      (org) =>
                        org.organizationId ===
                        result.preferences.defaultOrganization
                    );
                  }
                  this.user = result;
                  this.organizations = result.organizations;
                  this.update.next(this.organization);
                });
            });
          } else {
            if (!this.organization)
              this.organization = loginResult.currentOrganization;

            this.user = loginResult.currentUser;
            this.organizations = loginResult.organizations;
            this.update.next(this.organization);
          }
        });

        //this.getCurrentOrganization$ = userService.currentOrganization$;
        this.getCurrentUser$ = this.userService.currentUser$;
        if (
          this.userService.actions ||
          (this.organization && this.organization.roles)
        ) {
          this.userActions =
            this.userService.actions ||
            this.getActions(this.userService, this.organization.roles);
        }
      });

    this.getCurrentUser$.pipe(takeUntil(this.unSubscribeAll$)).subscribe({
      next: (res) => {
        this.user = res;
      },
      complete: () => {},
    });
  }
  ngOnDestroy(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  getActions(service: UserService, roles: string[]): string[] {
    return service.getActions(roles);
  }

  toggleFullWidth() {
    this.sidebarService.toggle();
    this.sidebarVisible = this.sidebarService.getStatus();
    // this.cdr.detectChanges();
  }

  goBack(): void {
    this.location.back();
  }

  setValueFromToken(): void {
    // Skip if flag is set (e.g., during dialog operations)
    if (this.skipSetValueFromToken) {
      return;
    }

    // If NGXS already has a currentOrganization in state, the org was established
    // by the login flow or an org-switch dispatch. Dispatching SetCurrentOrganization
    // again from here would fire a second (or third) concurrent API call, each of
    // which resets allRoles:undefined and re-dispatches SetRoles() — causing a
    // cascade of role state resets that crashes heavy pages like transactions/index.
    if (this.localStore.snapshot().application.currentOrganization) {
      return;
    }

    //Set Current Organization
    if (!this.organization && localStorage.getItem('organization')) {
      this.organization = JSON.parse(localStorage.getItem('organization'));
      this.localStore.dispatch(
        new App.Actions.SetCurrentOrganization(this.organization)
      );

      if (localStorage.getItem('user')) {
        const user = JSON.parse(localStorage.getItem('user')) as IMemberResult;

        if (user.organizations) {
          const organizations = user.organizations.map((org) => {
            return {
              address: org.organization['address'],
              name: org.organization['name'],
              id: org.organization['_id'],
              subscriptionStatus: org.organization.subscriptionStatus,
              organizationId: org.organization['_id'],
              roles: org.organization.roles,
              url: org.organization['url'],
              email: org.organization['email'],
              phone: org.organization['phone'],
              description: org.organization['description'],
              logo: org.organization['logo'],
              tags: org.organization['tags'],
            } as IOrganizationBase;
          });
          this.localStore.dispatch(
            new App.Actions.SetCurrentOrganization(user.currentOrganization)
          );
          this.localStore.dispatch(
            new App.Actions.SetOrganizations(organizations)
          );
          this.localStore.dispatch(new User.Actions.SetLoginInformation(user));
          this.localStore.dispatch(new App.Actions.SetRoles());
        }
      }
    }
  }
}
